"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const React = require("react");
const react_1 = require("react");
const CollapsibleContext_1 = require("../../../../../../contexts/CollapsibleContext");
const Collapse_1 = require("../../../../atoms/Collapse");
const styles = require("../../styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "baseSection");
/**
 * Renders the body of a block content.
 */
const Body = ({ children, className = "", noPadding = false }) => {
    const { isCollapsed } = (0, react_1.useContext)(CollapsibleContext_1.CollapsibleContext);
    const inner = (React.createElement("div", { "data-test": "body-inner", className: css("body_inner") }, children));
    return (React.createElement("div", { "data-test": "body", className: css("body", { "-noPadding": noPadding }, { className }) }, isCollapsed === undefined ? (inner) : (React.createElement(Collapse_1.Collapse, { isOpened: !isCollapsed }, inner))));
};
exports.Body = Body;
//# sourceMappingURL=index.js.map